export const goCardlessAPIUrls = {
  connect: '/auth/connect/',
  disconnect: '/auth/disconnect/',
  checkStatus: '/auth/{COMPANY_ID}/status',
};
